import ApiService from '@/common/api.service'

export default {
    getItemData () {
        return new Promise((resolve, reject) => {
            ApiService.query('/choice-item/list').then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    createTaxCal (data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/tax-cal/member/create', data).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getInformTaxCal (data) {
        return new Promise((resolve, reject) => {
            ApiService.post('/tax-cal/member/inform/' + data).then(response => {
                resolve(response)
            })
        })
    },
    getInformEstimates () {
        return new Promise((resolve, reject) => {
            ApiService.query('/tax-cal/list/addAndBase').then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    getConsumptionTax (price) {
        return new Promise((resolve, reject) => {
            ApiService.query(`/tax-cal/consumptionTax?price=${price}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
